import { render, staticRenderFns } from "./dev-reboot-result.vue?vue&type=template&id=24dee4df&scoped=true&"
import script from "./dev-reboot-result.vue?vue&type=script&lang=js&"
export * from "./dev-reboot-result.vue?vue&type=script&lang=js&"
import style0 from "./dev-reboot-result.vue?vue&type=style&index=0&id=24dee4df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dee4df",
  null
  
)

export default component.exports